import { baseAuthApi } from "../../../../core/service/baseApi";

export const configurationApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        loadComponentConfig: builder.query<{ items: Record<string, string>[] }, string>({
            providesTags: ["mainCache"],
            query: (configKey) => `/configurations/${configKey}`,
        }),
    }),
});

export const { useLoadComponentConfigQuery } = configurationApi;
